import { Components, Theme } from '@mui/material/styles';
import { borderRadius } from '../foundations/shape';

export const MuiButton: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      borderRadius: borderRadius.medium,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 13,
      lineHeight: '20px',
      minHeight: 32,
      padding: '5px 12px',
      boxShadow:
        ownerState.variant === 'text'
          ? 'none'
          : theme.palette.studio.shadows.button,
      transition: theme.transitions.create([
        'background-color',
        'border-color',
        'box-shadow',
        'transform',
      ]),
      '&:hover': {
        boxShadow:
          ownerState.variant === 'text'
            ? 'none'
            : theme.palette.studio.shadows.button,
      },
      '&:active': {
        transform: 'translateY(1px)',
        boxShadow:
          ownerState.variant === 'text'
            ? 'none'
            : theme.palette.studio.shadows.buttonPressed,
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: '2px',
      },
    }),
    contained: ({ theme }) => ({
      border: '1px solid transparent',
      '&:hover': {
        boxShadow: theme.palette.studio.shadows.button,
      },
    }),
    sizeLarge: {
      minHeight: 36,
      padding: '7px 16px',
      fontSize: 14,
      borderRadius: borderRadius.large,
    },
    sizeSmall: {
      minHeight: 28,
      padding: '3px 10px',
      fontSize: 12.5,
      borderRadius: borderRadius.small,
    },
  },
  defaultProps: {
    disableElevation: true,
  },
  variants: [
    {
      props: { variant: 'neutral' },
      style: ({ theme }) => ({
        color: theme.palette.text.secondary,
        border: `1px solid ${theme.palette.studio.borders.subtle}`,
        backgroundColor: theme.palette.studio.surfaces.fillSubtle,
        boxShadow: theme.palette.studio.shadows.button,
        minHeight: 32,
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.text.primary,
        },
      }),
    },
  ],
};
